angular.module('aprima-core-ui').directive('apMessageNotes', ['$sce', '_', function ($sce, _) {
    'use strict';

    return {
        scope: {
            message: '=',
            messageNotes: '=',
        },
        templateUrl: '/core-ui/views/directives/apMessageNotes.html',
        link: link,
    };

    function link(scope) {
        if (scope.messageNotes) {
            watchMessageNotes(scope);
        }
    }

    function watchMessageNotes(scope) {
        var dereg = scope.$watchCollection('messageNotes', function(newNotes) {
            _.forEach(newNotes, function (val) {
                // PRM shows the CreatedDate, but older servers only provided LastModificationDate.
                val.DisplayDate = val.CreatedDate ? val.CreatedDate : cal.LastModificationDate;
                val.NoteAsHtml = $sce.trustAsHtml(val.Note);
            });
        });

        scope.$on('$destroy', dereg);
    }
}]);